var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 449.69 449.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m224.85,0C100.67,0,0,100.67,0,224.85s100.67,224.85,224.85,224.85,224.85-100.67,224.85-224.85S349.03,0,224.85,0Zm-74.42,349.75h-50.64v-170.04h50.64v170.04Zm-25.63-195.04c-16.88,0-30.01-13.75-30.01-30.63s13.13-30.63,30.01-30.63,30.63,13.75,30.63,30.63-13.75,30.63-30.63,30.63Zm225.05,106.27v88.77h-50.01v-91.9c-.63-19.38-13.75-34.38-33.13-34.38s-35.63,15-36.26,34.38v91.9h-50.01v-170.04h50.01v23.76c10.63-15.63,28.13-25.63,48.14-25.63h13.75c31.88,0,57.51,26.26,57.51,57.51v25.63Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -90.24,
    y: -59.76,
    width: 630.17,
    height: 569.22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.1b57b8611d6f6e105a80317cea52a183.svg";
export { ForwardRef as ReactComponent };